import { useQuery } from '@tanstack/react-query'
import { getAirportLocations } from '~/services/locationService'

type QueryOptions = {
  partnerId: string
  enabled: boolean
  originAirport?: string
}

export function useQueryAirportsList({ partnerId, originAirport, enabled = true }: QueryOptions) {
  const { data } = useQuery({
    queryKey: ['airports', partnerId, originAirport],
    queryFn: async () => {
      const results = await getAirportLocations({ partnerId, fromAirport: originAirport })
      results.sort((airportA, airportB) => airportA.airportName.localeCompare(airportB.airportName))
      return results
    },
    enabled,
    meta: {
      notifyUser: true,
      errorMessage: 'Location Error - could not get airports',
    },
  })

  return data
}
